/**
 * Sidebar nav overflow fades (JEP-10471).
 * Set to `false` to hide the fades without deleting CSS or template markup.
 */
export const NAV_OVERFLOW_FADE_ENABLED = true;

const SCROLL_EDGE_PX = 1;

export interface NavOverflowFadeState {
	moreAbove: boolean;
	moreBelow: boolean;
}

export function navOverflowFadeState(
	scrollTop: number,
	clientHeight: number,
	scrollHeight: number,
	enabled: boolean = NAV_OVERFLOW_FADE_ENABLED
): NavOverflowFadeState {
	if (!enabled) {
		return { moreAbove: false, moreBelow: false };
	}

	const maxScroll = Math.max(0, scrollHeight - clientHeight);
	return {
		moreAbove: scrollTop > SCROLL_EDGE_PX,
		moreBelow: scrollTop < maxScroll - SCROLL_EDGE_PX,
	};
}
